// src/LoginPage.js
import { useState } from "react";
import { login as apiLogin } from "./api";
import { saveSession } from "./authStore";

export default function LoginPage({ onLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [persist, setPersist] = useState(true);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setErr("");
    try {
      const data = await apiLogin(username, password);
      saveSession(
        {
          access_token: data.access_token,
          refresh_token: data.refresh_token,
          profile: data.profile,
        },
        persist
      );
      onLoggedIn(data.profile);
    } catch {
      setErr("Invalid username or password");
    } finally {
      setBusy(false);
    }
  };

  const card = { maxWidth: 460, margin: "60px auto", padding: 18 };
  const panel = {
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    padding: 18,
  };

  const input = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    outline: "none",
  };

  return (
    <div style={card}>
      <div style={panel}>
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 20, fontWeight: 900 }}>SmartSight360</div>
          <div style={{ fontSize: 13, color: "#6b7280" }}>Sign in to continue</div>
        </div>

        <label style={{ fontSize: 13, fontWeight: 700 }}>Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ ...input, margin: "6px 0 12px" }}
          autoCapitalize="none"
        />

        <label style={{ fontSize: 13, fontWeight: 700 }}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ ...input, margin: "6px 0 10px" }}
        />

        <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, fontSize: 13 }}>
          <input type="checkbox" checked={persist} onChange={(e) => setPersist(e.target.checked)} />
          Keep me logged in
        </label>

        {err && <div style={{ color: "#b91c1c", fontWeight: 700, marginBottom: 10 }}>{err}</div>}

        <button
          onClick={submit}
          disabled={busy}
          style={{
            padding: "10px 14px",
            width: "100%",
            borderRadius: 12,
            border: "1px solid #1d4ed8",
            background: busy ? "#93c5fd" : "#2563eb",
            color: "white",
            fontWeight: 800,
            cursor: busy ? "not-allowed" : "pointer",
          }}
        >
          {busy ? "Signing in..." : "Login"}
        </button>
      </div>
    </div>
  );
}
